import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const coupons = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
    code: null,
  }),
  mutations: {
    setCoupons(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedCoupons(state, payload) {
      state.selectedItems = payload;
    },
    setCouponPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getCoupons");
    },
    setCouponTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getCoupons");
    },
  },
  actions: {
    async getCoupons(store) {
      store.state.loading = true;
      await axios
        .post("CouponGroup/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setCoupons", res.data.data);
        });
    },
    async getCodes(store, id) {
      await axios
        .post("CouponGroup/get", {
          id,
        })
        .then((res) => {
          store.state.code = res.data.data.item;
        });
    },
    async toggleCoupon(store, payload) {
      var res = await axios.post("CouponGroup/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteCoupon(store, payload) {
      await axios
        .post("CouponGroup/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setCouponPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default coupons;



// WEBPACK FOOTER //
// ./src/store/coupons.js